/* eslint-env browser */

/**
 * Hamburger menu implementation
 */

(function () {
    const svgImages = document.querySelectorAll(".post-img img[src$='.svg']");
    
    // Loop through the images, grab their parents, and reset their styles
    svgImages.forEach(image => {
        image.style.borderWidth = '0';
        const imageParent = image.parentElement;
        imageParent.style.padding = '0';
        imageParent.style.border = 'none';
    })
})();